import React from 'react';
import reactDOM from 'react-dom';
import { Provider } from 'react-redux';
import UrlHelper from 'foundation/url-helper';
import store from 'general/js/store';
import { HOLE_ID_QS_NAME } from './enums';
import LiveHoleLayout from './live-hole-layout';

class LiveHole {
    constructor() {
        this.root = document.createElement('div');
        this.root.id = 'live-hole';
        document.body.appendChild(this.root);

        this.state = {
            activeHoleId: null
        };

        this.init();
    }

    init() {
        const holeId = this.getHoleIdFromQS();

        if (holeId) {
            this.show(Number(holeId));
        }
    }

    onDestroy() {
        reactDOM.unmountComponentAtNode(this.root);
    }

    getHoleIdFromQS() {
        return UrlHelper.getParamFromLocation(HOLE_ID_QS_NAME, window.location);
    }

    isValidHoleId(id) {
        if (!id) return false;

        return typeof id === 'number' && !Number.isNaN(id);
    }

    show = (id) => {
        if (!this.isValidHoleId(id)) {
            console.log('You must provide valid hole ID');
            return;
        }

        this.state.activeHoleId = id;
        this.render();
    }

    hide = () => {
        this.state.activeHoleId = null;
        reactDOM.unmountComponentAtNode(this.root);
    }

    render() {
        reactDOM.render(
            <Provider store={store}>
                <LiveHoleLayout
                    holeId={this.state.activeHoleId}
                    onClose={this.hide} />
            </Provider>,
            this.root
        );
    }
}

export default new LiveHole();
